module.exports = __webpack_public_path__ + "img/minting_mine.33158232.svg";